<template>
  <div class="plan_item">
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <div class="plan_item_advertisement">
      <!-- <img :src="banner" /> -->
      <img src="https://www.7859888tp.com/750-50.gif" />
    </div>
    <ul>
      <li v-for="(el, i) in data.list" :key="i" :class="{ li_win: el.ifWin }">
        <div class="qi">{{ el.qiShu }}一肖一码（六三一肖）</div>
        <div class="value">
          <div class="code">
            <span>{{ el.qiShu }}期推荐1️⃣肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.sx1"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
              <span style="color: #2716ec">--重点多压</span>
            </div>
          </div>
          <div class="code">
            <span>{{ el.qiShu }}期推荐3️⃣肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.sx3"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              ><span style="color: #2716ec">--稳准狠</span>
            </div>
          </div>
          <div class="code">
            <span>{{ el.qiShu }}期推荐6️⃣肖</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.sx6"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              ><span style="color: #2716ec">--平稳压</span>
            </div>
          </div>
          <div class="code">
            <span>{{ el.qiShu }}期精选12码</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.code12"
                :key="codeIndex"
                :class="{ win: code === el.code }"
                >{{ code }}</span
              >
            </div>
          </div>
          <div class="code">
            <span>{{ el.qiShu }}期精选6码</span>
            <div>
              <span
                v-for="(code, codeIndex) in el.yuCe.code6"
                :key="codeIndex"
                :class="{ win: code === el.shengXiao }"
                >{{ code }}</span
              >
            </div>
          </div>
        </div>
        <div v-if="!el.ifZuiXin" class="kaijiang">
          开 {{ el.code }} {{ el.shengXiao }}
        </div>
      </li>
    </ul>
  </div>
</template>
    
    <script setup>
import top from "@/assets/img/top.gif";
import { toRefs } from "vue";

const props = defineProps({
  data: Object,
});

const { data } = toRefs(props);
</script>
    
    <style lang="scss" scoped>
.title {
  text-align: center;
  background-color: #009788;
  font-size: 25px;
  font-weight: bold;
  padding: 6px 0;
}
.plan_item {
  border: 1px solid #009788;
  .plan_item_advertisement {
    img {
      width: 100%;
      height: 40px;
      display: block;
    }
  }
  .plan_item_title {
    font-weight: bold;
    text-align: center;
    background-image: linear-gradient(to bottom, #b4b9b1, #f1edeb);
    padding: 3px 0;
    border-top: 2px solid #767474;
    border-bottom: 2px solid #767474;
    img {
      width: 30px;
      height: 30px;
    }
  }
  ul {
    background-color: #eee;
    li {
      text-align: center;
      //   padding: 5px 12px;
      padding: 0;
      font-weight: bold;
      //   display: flex;
      justify-content: center;
      .qi {
        border-bottom: 1px solid #ccc;
        padding: 6px 32px;
        background-color: #fbefb8;
        color: red;
        text-align: left;
      }
      .value {
        color: red;
        > div {
          border-bottom: 1px solid #ccc;
          display: flex;
          > span {
            width: 30%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            color: #222;
          }
          > div {
            padding: 2px 12px;
            display: flex;
            flex-wrap: wrap;
            grid-gap: 12px;
            flex: 1;
            color: red;
            .win {
              color: red;
              background-color: #fcfb04;
              font-size: 120%;
            }
          }
        }
      }
      .kaijiang {
        padding: 6px 0;
        background-color: #b2ae32;
        color: red;
      }
      &:not(:last-child) {
        border-bottom: 2px solid #d2d2d2;
      }
    }
    .li_win {
      .winText {
        color: #d00880;
      }
    }
    .suck {
      text-decoration-line: line-through;
    }
  }
}
</style>